<script setup>
  import { defineEmits, defineProps, ref, computed, watch } from 'vue'

  import POKEMON_DATA from '../data/pokemon-base-data.json';

  import TypeBadge from './TypeBadge.vue';
  import PokemonIcon from "./PokemonIcon.vue";

  const emit = defineEmits(['select']);

  const props = defineProps({
    chosenBasename: String,
  });

  const searchInput = ref(null);

  const showingModal = ref(false);
  const inputValue = ref('');
  const lastChosen = ref(props.chosenBasename ?? null);


  const results = computed(() => {
    var shortlist = [];
    if (inputValue.value.length){
      for (var p in POKEMON_DATA) {
        if (POKEMON_DATA[p].name.toLowerCase().indexOf(inputValue.value.toLowerCase()) !== -1) {
          shortlist.push(POKEMON_DATA[p])
        }
      }
    }
    return shortlist
  });


  watch(showingModal, (newVal)=>{
    if (newVal){
      window.setTimeout(()=>{
        searchInput.value.focus();
      }, 100);
    }
  })

  const select = (clickedPokemon, extraData) => {
    lastChosen.value = clickedPokemon
    emit('select', clickedPokemon, extraData)
    showingModal.value = false;
  }

</script>

<template>
  <div class="cursor-pointer hover:shadow-xl" @click="showingModal=true">
    <slot name="chosen">
      <div class="flex items-center gap-4">
        <template v-if="lastChosen">
          <PokemonIcon :pokemon="lastChosen"/>
          <div class="grow">
            <div class="inline-block font-bold text-lg">{{lastChosen.name}}</div>
          </div>
        </template>
        <template v-else>
          <PokemonIcon/>
          <div class="grow">
            <div class="inline-block font-bold text-lg">Choose a Pokémon</div>
          </div>
        </template>
      </div>
    </slot>

    <Teleport to="body">
      <div
        v-if="showingModal"
        class="w-screen h-screen fixed top-0 left-0 bg-gray-300/50 dark:bg-neutral-800/50 flex"
        @click="showingModal = false"
      >
        <div
          class="m-auto w-[640px] max-w-full rounded-xl shadow-xl bg-white dark:bg-neutral-800 p-8 flex flex-col gap-4"
          @click.stop="()=>{}"
        >
          <input
            class="text-2xl rounded outline-primary border border-gray-300 dark:border-gray-800 dark:bg-gray-600 pl-8 pr-16 py-4"
            ref="searchInput"
            placeholder="Enter a Pokémon name..."
            v-model="inputValue"
          />
          <div class="grow max-h-[75vh] overflow-y-auto flex flex-col gap-2">
            <div
              v-for="(pokemon, p) in results" :key="p"
              class="flex items-center gap-4"
            >
              <PokemonIcon :pokemon="pokemon"/>
              <div class="grow">
                <div class="inline-block font-bold text-lg">{{ pokemon.name }}</div>
                <TypeBadge class="text-sm font-normal ml-4" :typeId="pokemon.types[0]" />
                <TypeBadge class="text-sm font-normal ml-2" v-if="pokemon.types[1]" :typeId="pokemon.types[1]" />
              </div>
              <slot name="controls" :pokemon="pokemon" :select="select">
                <div class="button bg-primary text-white hover:bg-primary-hover" @click="select(pokemon)">
                  Select
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

  </div>
</template>
